import { FormikProps } from 'formik';
import { TextFieldNoLabel } from '../../../components/index';
import { SignUpFormProps } from '../types/sign-up-form-types';

const ConfirmPasswordInput = ({formik} : {formik: any}) => {
  const inputProps = {
    value: formik.values.confirmPassword,
    onChange: formik.handleChange,
    error: formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword),
    helperText: formik.touched.confirmPassword && formik.errors.confirmPassword,
  }
  return (
    <TextFieldNoLabel textDesc="Confirm Password" name="confirmPassword" type='password' isRequired placeholder='Re-enter your password' isPassword inputProps={inputProps} />
  )
}

export default ConfirmPasswordInput;